import { FC, useEffect, useState } from 'react'

import { Customer } from 'commons/types/DTO/bank/companyDetails/customer'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSectionPrimary, Table } from 'ui/components'

import { handlerServerError } from '@orbit/errors'

import { CompanyCustomersTableProps } from './CompanyCustomersTableProps'
import { columns } from './columns'
import { Filter } from './components'
import { useComponentsEssence } from './hooks/useComponentsEssence'
import { useFilterCompanyCustomersWebPage } from './hooks/useFilterCompanyCustomersWebPage'

export const CompanyCustomersTable: FC<CompanyCustomersTableProps> = (props) => {
  const {
    data: { customers, customersTotalCount, id }
  } = props
  const [webPageData, setWebPageData] = useState({
    customers: customers,
    customersTotalCount: customersTotalCount
  })

  useEffect(() => {
    setWebPageData({
      customers: customers,
      customersTotalCount: customersTotalCount
    })
  }, [customers, customersTotalCount])

  const { routine: filterCompanyCustomersWebPage } = useFilterCompanyCustomersWebPage({
    onSuccess: async (_, result) => {
      await setWebPageData(result)
    },
    onError: (error) => handlerServerError(error)
  })

  const { loading, tableState, filterForm, changePagination, clearFilter } = useComponentsEssence(
    id,
    filterCompanyCustomersWebPage
  )

  return (
    <PageSectionPrimary face="outlined" title="Customers" anchor="customers">
      <Layer rounded shadowed stretch>
        <Filter
          form={filterForm}
          expanded={tableState.expanded}
          onToggle={tableState.onFilterToggle}
          onClear={clearFilter}
        />
        <Table<Customer>
          dataQa={TableDataQa.BP_COMPANY_CUSTOMERS}
          columns={columns}
          dataSource={webPageData.customers.map((el) => ({
            item: el
          }))}
          loading={loading}
          pagination={{
            page: tableState.page,
            size: tableState.size,
            onChange: changePagination,
            total: webPageData.customersTotalCount
          }}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
